import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useExperienceWizard } from 'core/contexts/experienceWizard';
import { ExperienceInclusions } from '@utriper/core';
import { Form } from 'react-final-form';
import { Box } from '@mui/material';
import { AlertDialog } from '@utriper/core-ui';
import Title from 'modules/Pricing/components/Title';
import ActionButtons from 'modules/Pricing/PriceGroupWizard/components/ActionButtons';
import AddIncludesOptionForm from '../AddIncludesOptionForm';
import IncludesFormFields from './components/IncludesFormFields';

const IncludesForm = () => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_form.${key}`);
    const { stepData, handleBack, handleNext, updateStepData, STEP_KEYS, setCustomIncludes, setCustomNotIncludes } = useExperienceWizard();
    const [openAdd, setOpenAdd] = useState(false);
    const [typeForm, setTypeForm] = useState(null);

    const handleOpenAddForm = (typeForm) => {
        setOpenAdd(true);
        setTypeForm(typeForm);
    };

    const handleCloseForm = () => {
        setOpenAdd(false);
        setTypeForm(null);
    };

    const handleAddOption = ({ newOption }) => {
        if (!newOption || !typeForm) return;
        const uniqueId = `custom-${new Date().getTime()}-${Math.random()}`;

        const includeOption = {
            id: uniqueId,
            includesId: null,
            label: newOption,
            disabled: false,
        };

        if (typeForm === ExperienceInclusions.IDS.included) {
            setCustomIncludes((prev) => [...prev, includeOption]);
            return;
        }

        setCustomNotIncludes((prev) => [...prev, includeOption]);
    };

    const handleSubmit = (values) => {
        updateStepData(STEP_KEYS.STEP_6, values);
        handleNext();
    };

    const validateForm = (values) => {
        const errors = {};

        return errors;
    };

    return (
        <Form
            onSubmit={handleSubmit}
            validate={validateForm}
            initialValues={stepData[STEP_KEYS.STEP_6]}
            render={({ handleSubmit }) => {
                return (
                    <form onSubmit={handleSubmit} noValidate style={{ width: '100%', maxWidth: '480px' }}>
                        <Box component="section">
                            <Title title={translate('add_includes.title')} description={translate('add_includes.description')} />

                            <IncludesFormFields handleOpenAddForm={handleOpenAddForm} />

                            <ActionButtons
                                handleSubmit={(e) => {
                                    return handleSubmit(e);
                                }}
                                handleBack={handleBack}
                            />
                        </Box>

                        {/* Add Dialog */}
                        <AlertDialog open={openAdd} handleClose={handleCloseForm} hideTitle hideActions maxWidth="sm" fullWidth dialogContent={<AddIncludesOptionForm onAddOption={handleAddOption} onClose={handleCloseForm} placeholder={translate('includes_placeholder')} />} />
                    </form>
                );
            }}
        />
    );
};

export default IncludesForm;
